module.exports = __webpack_public_path__ + "static/media/left arrow icon.d9028314.svg";